import { Application, Container } from 'pixi.js';
import { addResizeListener } from './display';
import { Game } from './game';
import { theme } from 'game/theme';
import { CanvasRenderer } from '@pixi/canvas-renderer';
import { extensions } from '@pixi/core';

// Register the canvas renderer
export type AppSetting = {
    backgroundColor?: number;
    backgroundAlpha?: number;
};
const defaultAppSettings = {
    backgroundColor: theme.gameBackground,
    backgroundAlpha: 1,
} as AppSetting;
class PixiRenderer {
    app: Application;
    stageContainer: Container;

    constructor() {
        this.onResize = this.onResize.bind(this);
        this.render = this.render.bind(this);
        this.stageContainer = new Container();
        extensions.add(CanvasRenderer);

        this.app = new Application();
    }
    async initApp(option: AppSetting) {
        const settings = { ...defaultAppSettings, ...option };
        await this.app.init({
            resolution: window.devicePixelRatio,
            autoDensity: true,
            antialias: false,
            useBackBuffer: true,
            background: settings.backgroundColor,
            backgroundAlpha: settings.backgroundAlpha,
        });

        this.startApp();
    }
    startApp() {
        const gameContainer = document.getElementById('solitaire-container');
        if (!gameContainer) {
            setTimeout(() => {
                this.startApp();
            }, 100);
            return;
        }
        gameContainer.appendChild(this.app.canvas);
        this.app.stage.addChild(this.stageContainer);
        addResizeListener(this.onResize, 'rendererResize');
        Game.start();

        setTimeout(() => {
            this.app.canvas.classList.add('loaded');
        }, 10);
    }
    onResize(width: number, height: number) {
        this.app.renderer.resize(width, height);
    }
    render() {
        this.app.renderer.render(this.app.stage);
    }
}

export const App = new PixiRenderer();

class GameTime {
    get deltaTime() {
        return App.app ? App.app.ticker.deltaTime : 1;
    }
    get deltaTimeMS() {
        return App.app ? App.app.ticker.deltaMS : 1;
    }
}
export const Time = new GameTime();
